import "./admin.css";
import { useState, useEffect, useCallback } from "react";
import LoginScreen from "../LoginScreen/LoginScreen";
import DashboardPage   from "./pages/DashboardPage";
import UploadPage      from "./pages/UploadPage";
import ImagesPage      from "./pages/ImagesPage";
import HeroEditorPage  from "./pages/HeroEditorPage";
import ServicesEditorPage from "./pages/ServicesEditorPage";
import UsersPage       from "./pages/UsersPage";
import LeadsPage from "./pages/LeadsPage";

/* ============================================================
   DESIGN TOKENS
   ============================================================ */
export const T = {
  primary:   "#123133",
  accent:    "#10c9a5",
  accentHov: "#0eb894",
  yellow:    "#FCE94E",
  cream:     "#F9EBDE",
  white:     "#ffffff",
  bg:        "#f4f6f5",
  border:    "rgba(18,49,51,0.12)",
  borderMd:  "rgba(18,49,51,0.22)",
  text:      "#123133",
  textMuted: "rgba(18,49,51,0.5)",
  textHint:  "rgba(18,49,51,0.35)",
  danger:    "#c0392b",
  dangerBg:  "#fdecea",
};

export const API = (window._ADMIN_API_URL || process.env?.REACT_APP_API_URL || "/api/v1");

export const SECTIONS = [
  { value: "gallery",  label: "Галерея проектов" },
  { value: "services", label: "Услуги" },
  { value: "hero",     label: "Главный экран" },
];

export const GALLERY_CATS = [
  "Серверные / ЦОД", "СКС и сети", "Электрика",
  "AV-системы", "Автоматизация", "Стройка / Команда", "Промышленность",
];

export const PAGE_TITLES = {
  dashboard: "Обзор",
  upload:    "Загрузка",
  images:    "Изображения",
  leads:     "Заявки",   
  hero:      "Главный экран",
  services:  "Услуги",
  users:     "Пользователи",
};

const NAV = [
  { id: "dashboard", label: "Обзор",        icon: "Dashboard" },
  { id: "upload",    label: "Загрузить",     icon: "Upload"    },
  { id: "images",    label: "Изображения",   icon: "Images"    },
  { id: "leads",     label: "Заявки",        icon: "Users"     }, 
  { id: "hero",      label: "Главный экран", icon: "Images"    },
  { id: "services",  label: "Услуги",        icon: "Images"    },
  { id: "users",     label: "Пользователи",  icon: "Users"     },
];

/* ============================================================
   SVG ICONS
   ============================================================ */
export const Icon = {
  Images:    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="3" y="3" width="18" height="18" rx="1"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>,
  Upload:    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><polyline points="16 16 12 12 8 16"/><line x1="12" y1="12" x2="12" y2="21"/><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"/></svg>,
  Edit:      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>,
  Trash:     <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>,
  Users:     <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>,
  Dashboard: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>,
  Close:     <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>,
  Check:     <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><polyline points="20 6 9 17 4 12"/></svg>,
  Plus:      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>,
  Arrow:     <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>,
  Shield:    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>,
  Sort:      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>,
  Refresh:   <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/></svg>,
  Eye:       <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>,
  Logout:    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><polyline points="16 17 21 12 16 7" /><line x1="21" y1="12" x2="9" y2="12" /></svg>
};

/* ============================================================
   JWT HELPERS
   ============================================================ */
function parseJwt(token) {
  try {
    return JSON.parse(atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")));
  } catch {
    return null;
  }
}

function isTokenExpired(token) {
  const payload = parseJwt(token);
  if (!payload?.exp) return true;
  return payload.exp * 1000 < Date.now();
}

function isTokenAdmin(token) {
  const payload = parseJwt(token);
  return payload?.role === "admin";
}

/* ============================================================
   TOAST SYSTEM
   ============================================================ */
export function useToast() {
  const [toasts, setToasts] = useState([]);
  const add = useCallback((msg, type = "success") => {
    const id = Date.now();
    setToasts(t => [...t, { id, msg, type }]);
    setTimeout(() => setToasts(t => t.filter(x => x.id !== id)), 3200);
  }, []);
  return { toasts, add };
}

function ToastContainer({ toasts }) {
  return (
    <div className="adm-toast-wrap">
      {toasts.map(t => (
        <div key={t.id} className={`adm-toast adm-toast--${t.type}`}>
          {t.type === "success" ? Icon.Check : Icon.Close}
          {t.msg}
        </div>
      ))}
    </div>
  );
}

/* ============================================================
   API HOOK
   ============================================================ */
export function useApi(token, onExpired) {
  const headers = useCallback((extra = {}) => ({
    Authorization: `Bearer ${token}`,
    ...extra,
  }), [token]);

  const handle = useCallback(async (r) => {
    if (r.status === 401 || r.status === 403) {
      onExpired?.();
      throw new Error("SESSION_EXPIRED");
    }
    if (!r.ok) {
      const d = await r.json().catch(() => ({}));
      throw new Error(d.detail || `HTTP ${r.status}`);
    }
    return r.json();
  }, [onExpired]);

  const get = useCallback(async (path) => {
    const r = await fetch(`${API}${path}`, { headers: headers() });
    return handle(r);
  }, [headers, handle]);

  const post = useCallback(async (path, body) => {
    const r = await fetch(`${API}${path}`, {
      method: "POST",
      headers: headers({ "Content-Type": "application/json" }),
      body: JSON.stringify(body || {}),
    });
    return handle(r);
  }, [headers, handle]);

  const del = useCallback(async (path) => {
    const r = await fetch(`${API}${path}`, { method: "DELETE", headers: headers() });
    return handle(r);
  }, [headers, handle]);

  const patch = useCallback(async (path, body) => {
    const r = await fetch(`${API}${path}`, {
      method: "PATCH",
      headers: headers({ "Content-Type": "application/json" }),
      body: JSON.stringify(body),
    });
    return handle(r);
  }, [headers, handle]);

  const upload = useCallback(async (path, formData) => {
    const r = await fetch(`${API}${path}`, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      body: formData,
    });
    return handle(r);
  }, [token, handle]);

  return { get, post, del, patch, upload };
}

/* ============================================================
   SIDEBAR
   ============================================================ */
function Sidebar({ page, onNav, user, onLogout }) {
  return (
    <aside className="adm-sidebar">
      <div className="adm-sidebar__logo">
        <div className="adm-sidebar__logo-title">ITS Admin</div>
        <div className="adm-sidebar__logo-sub">Панель управления</div>
      </div>
      <nav className="adm-sidebar__nav">
        <div className="adm-nav-section">Навигация</div>
        {NAV.map(n => (
          <button
            key={n.id}
            className={`adm-nav-btn${page === n.id ? " active" : ""}`}
            onClick={() => onNav(n.id)}
          >
            {Icon[n.icon]}
            {n.label}
          </button>
        ))}
      </nav>
      <div className="adm-sidebar__footer">
        <div style={{ marginBottom: 10 }}>
          <div style={{ color: "rgba(255,255,255,0.6)", fontWeight: 500 }}>{user?.username}</div>
          <div style={{ fontSize: 10, marginTop: 2 }}>{user?.email}</div>
        </div>
        <button
          className="adm-btn adm-btn--sm"
          style={{ borderColor: "rgba(255,255,255,0.2)", color: "rgba(255,255,255,0.6)", width: "100%", justifyContent: "center" }}
          onClick={onLogout}
        >
          {Icon.Logout} Выйти
        </button>
      </div>
    </aside>
  );
}

/* ============================================================
   ROOT
   ============================================================ */
export default function AdminPanel() {
  const [auth, setAuth] = useState(() => {
    try {
      const stored = JSON.parse(localStorage.getItem("adm_auth") || "null");
      if (!stored?.access_token)               { return null; }
      if (isTokenExpired(stored.access_token)) { localStorage.removeItem("adm_auth"); return null; }
      if (!isTokenAdmin(stored.access_token))  { localStorage.removeItem("adm_auth"); return null; }
      return stored;
    } catch {
      return null;
    }
  });
  const [page, setPage] = useState("dashboard");
  const { toasts, add: toast } = useToast();

  useEffect(() => { window._admNav = setPage; return () => { delete window._admNav; }; }, []);

  useEffect(() => {
    if (!auth) return;
    const id = setInterval(() => {
      if (isTokenExpired(auth.access_token)) handleLogout();
    }, 30_000);
    return () => clearInterval(id);
  }, [auth]);

  const handleLogin = (data) => {
    if (!data?.access_token || !isTokenAdmin(data.access_token)) return;
    localStorage.setItem("adm_auth", JSON.stringify(data));
    setAuth(data);
  };

  const handleLogout = () => {
    localStorage.removeItem("adm_auth");
    setAuth(null);
  };

  if (!auth) return <LoginScreen onLogin={handleLogin} />;

  const token = auth.access_token;

  return (
    <div className="adm-root" style={{ display: "flex" }}>
      <Sidebar page={page} onNav={setPage} user={auth.user} onLogout={handleLogout} />
      <main className="adm-main">
        <div className="adm-topbar">
          <span className="adm-topbar__title">{PAGE_TITLES[page]}</span>
          <div className="adm-topbar__right">
            <span style={{ fontSize: 12, color: T.textHint }}>
              {new Date().toLocaleDateString("ru-RU", { weekday: "short", day: "numeric", month: "long" })}
            </span>
            <span className="adm-tag adm-tag--accent">{Icon.Shield} Суперпользователь</span>
          </div>
        </div>
        <div className="adm-content">
          {page === "dashboard" && <DashboardPage   token={token} onExpired={handleLogout} />}
          {page === "upload"    && <UploadPage       token={token} toast={toast} onExpired={handleLogout} />}
          {page === "images"    && <ImagesPage       token={token} toast={toast} onExpired={handleLogout} />}
          {page === "leads"     && <LeadsPage        token={token} toast={toast} onExpired={handleLogout} />} 
          {page === "users"     && <UsersPage        token={token} toast={toast} onExpired={handleLogout} />}
          {page === "hero"      && <HeroEditorPage   token={token} toast={toast} onExpired={handleLogout} />}
          {page === "services"  && <ServicesEditorPage token={token} toast={toast} onExpired={handleLogout} />}
        </div>
      </main>
      <ToastContainer toasts={toasts} />
    </div>
  );
}